import { OptionType } from 'components/form';

/**
 * Only specific sources are offered. The umbrella options that used to sit here
 * ('Social Media', 'Company Website') overlapped the specific ones listed below
 * them — LinkedIn/WhatsApp/Twitter are social media, and Precision *is* the
 * company website — which split the same answer across two entries.
 *
 * Responses already recorded against the retired values still render, via the
 * title-cased fallback in getRoleSourceLabel.
 */
export const ROLE_SOURCE_OPTIONS: OptionType[] = [
  { label: 'Job Board', value: 'job_board' },
  { label: 'Referral', value: 'referral' },
  { label: 'Recruiter', value: 'recruiter' },
  { label: 'Indeed', value: 'indeed' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'WhatsApp', value: 'whatsapp' },
  { label: 'Precision', value: 'precision' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'Other', value: 'other' },
];

const ROLE_SOURCE_LABEL_MAP = ROLE_SOURCE_OPTIONS.reduce<Record<string, string>>((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

export const getRoleSourceLabel = (sourceName: string) => {
  return ROLE_SOURCE_LABEL_MAP[sourceName] || sourceName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
